var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4404_5254)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 0.5C2.69569 0.5 0 3.19569 0 6.5C0 9.80431 2.69569 12.5 6 12.5C9.30431 12.5 12 9.80431 12 6.5C12 3.19569 9.30431 0.5 6 0.5ZM6.82626 8.67442L6.26104 8.89181L6.91322 5.50049C6.9567 5.32658 6.86974 5.15266 6.73931 5.02224C6.60887 4.93528 6.39148 4.8918 6.26105 4.97876L5.04365 5.6744C4.82626 5.80484 4.7393 6.06572 4.86974 6.2831C5.00017 6.50049 5.26105 6.58745 5.47844 6.45702L5.82627 6.23963L5.17409 9.50044C5.13061 9.67436 5.21757 9.84827 5.348 9.93522C5.43496 10.0222 5.52192 10.0222 5.65235 10.0222C5.69583 10.0222 5.78279 10.0222 5.82627 9.9787L7.17409 9.41348C7.39148 9.32652 7.52192 9.02217 7.39148 8.80478C7.30452 8.67434 7.04365 8.54391 6.82626 8.67435V8.67442ZM6.95674 3.89047C6.82631 3.97743 6.6524 4.06438 6.47848 4.06438C6.30457 4.06438 6.17414 4.02091 6.00023 3.89047C5.91327 3.76005 5.82631 3.58612 5.82631 3.41221C5.82631 3.23831 5.86979 3.06439 6.00023 2.93396C6.13065 2.847 6.30457 2.76004 6.47848 2.76004C6.65239 2.76004 6.8263 2.80352 6.95674 2.93396C7.04369 3.06438 7.13065 3.23831 7.13065 3.41221C7.13065 3.58612 7.08717 3.76004 6.95674 3.89047Z",
    fill: "#C62828"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4404_5254"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.43e35ec81afcf458c31b16a94d193c61.svg";
export { ForwardRef as ReactComponent };